.btn-information{margin:10px 0 0 10px;padding:3px 9px}.pagination{margin:10px 0}
/*# sourceMappingURL=test-case-template-table.component-N5ND7Y7V.css.map */
